import { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { CampaignMode, MediaTypeId, IMediaType } from '../../interfaces/campaign';
import AdTypeBox from './AdTypeBox';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import { isCampaignCreateMode } from '../../utils/string';
import { useSearchParams } from 'react-router-dom';

type IAdvertisementType = {
	mode: CampaignMode;
};

const AdvertisementType: FC<IAdvertisementType> = ({ mode }) => {
	const { setSelectedMediaTypeId, fetchedMedias, selectedMediaTypeId, selectedPlatform, selectedPlatformId, fetchedCampaign } = useContext(CampaignContext);
	const { t } = useTranslation();

	const isCreateMode = isCampaignCreateMode(mode);

	const handleSelectAdType = (type: MediaTypeId) => {
		if (isCreateMode) {
			setSelectedMediaTypeId?.(type);
		}
	};

	const [searchParams] = useSearchParams();
	const media_params = searchParams.get('media');
	const selectedMedia = isCreateMode ? selectedPlatform : fetchedCampaign?.media;
	const filteredPlatform = fetchedMedias?.find(media => {
		if (media_params) {
			return media.system_name === media_params;
		} else {
			return media.id === selectedPlatformId;
		}
	});
	const filteredMedias = fetchedMedias?.filter(media => media.system_name === selectedMedia);
	const adTypes: IMediaType[] = (filteredMedias && filteredMedias[0]?.types) || [];
	return (
		<>
			{filteredPlatform && filteredPlatform.types.length > 0 && (
				<Box className="mt-4 flex items-center rounded-lg bg-background-paper px-6 pb-8 pt-6">
					<Typography className="me-6 text-xl text-text-primary">{t('ad_type')}</Typography>
					<Box className="ml-4 flex flex-1 flex-wrap gap-4">
						{adTypes?.map((type, i) => (
							<Box
								key={i}
								style={{
									width: type.id === 'influenceral' ? '100%' : 'calc(50% - 8px)',
								}}
							>
								<AdTypeBox adType={type} selected={type.id === 'influenceral' ? true : isCreateMode ? selectedMediaTypeId === type.id : fetchedCampaign?.media_type_id === type.id} campaignMode={mode} onSelect={() => handleSelectAdType(type.id as MediaTypeId)} />
							</Box>
						))}
					</Box>
				</Box>
			)}
		</>
	);
};

export default AdvertisementType;
